const portalUrl = process.env.PORTAL_URL;
const domain = portalUrl?.replace('https://', '')?.replace('http://', '');

export const isPortalAppUrl = (url: string): boolean => {
  if (!url) return false;
  
  const isPortalAppRegex = new RegExp(`^(https?://.*${domain})?/app/`);
  return isPortalAppRegex.test(`${portalUrl}/app/`) || url.startsWith('/app/');
};

export const redirectToService = (url: string, portalConnect?: any): void => {
  if (!url) return;

  if (isPortalAppUrl(url)) {
    portalConnect?.redirectTo(url);
  } else {
    window.open(url, '_blank');
  }
};
